import React, { useState, useEffect } from "react";
import { getApiUrl, BASE_URL } from "../utils/api";
import placeholder from "../assets/sampleimage.png";

const SampleGallery = () => {
  const [images, setImages] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const fetchImages = async () => {
    try {
      const res = await fetch(getApiUrl("samplebanner-list"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });
      const result = await res.json();
      if (result.success) setImages(result.data || []);
    } catch (err) {
      console.error("Failed to load images");
    }
  };

  useEffect(() => {
    fetchImages();
  }, []);

  const handlePrev = () => {
    setSelectedIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setSelectedIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className="container my-3">
      <h3 className="text-center fw-bold pb-3">OURS GALLERY</h3>
      <div className="row g-2">
        {(images.length ? images : Array.from({ length: 10 })).map((img, idx) => (
          <div
            key={idx}
            className="col-6 col-md-4 col-lg-3" 
          >
            <img
              src={img ? `${BASE_URL}${img}` : placeholder}
              alt={`Banner ${idx + 1}`}
              className="img-fluid rounded w-100"
              style={{ cursor: "pointer" }}
              onClick={() => setSelectedIndex(idx)}
            />
          </div>
        ))}
      </div>

      {selectedIndex !== null && (
        <div
          onClick={() => setSelectedIndex(null)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.85)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <button
            onClick={(e) => { e.stopPropagation(); setSelectedIndex(null); }}
            style={{
              position: "absolute",
              top: "20px",
              right: "20px",
              fontSize: "2rem",
              color: "#fff",
              background: "none",
              border: "none",
              cursor: "pointer",
            }}
          >
            &times;
          </button>

          <button
            onClick={(e) => { e.stopPropagation(); handlePrev(); }}
            style={{
              position: "absolute",
              left: "20px",
              fontSize: "2rem",
              color: "#fff",
              background: "none",
              border: "none",
              cursor: "pointer",
            }}
          >
            &#60;
          </button>

          <img
            src={images[selectedIndex] ? `${BASE_URL}${images[selectedIndex]}` : placeholder}
            alt="Selected"
            style={{
              objectFit: "contain",
              maxWidth: "90%",
              maxHeight: "90%",
              borderRadius: "8px",
            }}
          />

          <button
            onClick={(e) => { e.stopPropagation(); handleNext(); }}
            style={{
              position: "absolute",
              right: "20px",
              fontSize: "2rem",
              color: "#fff",
              background: "none",
              border: "none",
              cursor: "pointer",
            }}
          >
            &#62;
          </button>
        </div>
      )}
    </div>
  );
};

export default SampleGallery;
